<div class="criterion-row-container" cdkDrag cdkDragBoundary=".rules-list" cdkDragLockAxis="y">
    <div [class]="tabClass()">
        @if (displayIndex()) {
            {{ index() + 1 }}
        }
    </div>
    <div class="criterion-container">
        <div class="criterion-content">
            <div [class]="badgeClass()">
                <fa-icon [icon]="badgeIcon()" />
                {{ type() }}
            </div>
            <div class="field-comparator-row">
                <mat-form-field class="table-name-form-field">
                    <mat-label>Table Name</mat-label>
                    <mat-select [formControl]="criterionForm.controls.tableName">
                        @for (table of sortedTables(); track $index) {
                            <mat-option [value]="table.name" (click)="onTableSelect(table.name)">
                                {{ table.displayName }}
                            </mat-option>
                        }
                    </mat-select>
                    @if (criterionForm.controls.tableName.errors?.['required']) {
                        <mat-error>Value required</mat-error>
                    }
                </mat-form-field>
                <mat-form-field class="fields-dropdown">
                    <mat-label>Select a Field</mat-label>
                    <mat-select [formControl]="criterionForm.controls.dataMartFieldName">
                        @for (field of sortedFields(); track $index) {
                            <mat-option [value]="field.name" (click)="onFieldSelect(field)"
                                >{{ field.displayName }}
                            </mat-option>
                        }
                    </mat-select>
                    @if (criterionForm.controls.dataMartFieldName.errors?.['required']) {
                        <mat-error>Value required</mat-error>
                    }
                </mat-form-field>
                <div class="checkbox-container">
                    <mat-checkbox [formControl]="criterionForm.controls.not">Not</mat-checkbox>
                </div>
                <mat-form-field class="comparator-dropdown">
                    <mat-label>Comparator</mat-label>
                    <mat-select [formControl]="criterionForm.controls.comparator">
                        @for (comparator of comparators(); track $index) {
                            <mat-option (click)="onComparatorSelect()" [value]="comparator.value"
                                >{{ comparator.label }}
                            </mat-option>
                        }
                    </mat-select>
                    @if (criterionForm.controls.comparator.errors?.['required']) {
                        <mat-error>Value required</mat-error>
                    }
                </mat-form-field>
            </div>
            <div class="value-row">
                @switch (selectedComparatorValueType()) {
                    @case ('text') {
                        <mat-form-field class="single-value-form-field">
                            <mat-label>Value</mat-label>
                            <input matInput [formControl]="criterionForm.controls.value1.controls.value" />
                            @if (criterionForm.controls.value1.controls.value.errors?.['required']) {
                                <mat-error>Value required</mat-error>
                            } @else if (criterionForm.controls.value1.controls.value.errors?.['invalidInputForType']) {
                                <mat-error>{{
                                    criterionForm.controls.value1.controls.value.errors!['invalidInputForType'].message
                                }}</mat-error>
                            }
                        </mat-form-field>
                    }
                    @case ('text&text') {
                        <div class="double-value-form-container">
                            <mat-form-field class="double-value-form-field-1">
                                <mat-label>Value</mat-label>
                                <input matInput [formControl]="criterionForm.controls.value1.controls.value" />
                                @if (criterionForm.controls.value1.controls.value.errors?.['required']) {
                                    <mat-error>Value required</mat-error>
                                } @else if (
                                    criterionForm.controls.value1.controls.value.errors?.['invalidInputForType']
                                ) {
                                    <mat-error>{{
                                        criterionForm.controls.value1.controls.value.errors!['invalidInputForType']
                                            .message
                                    }}</mat-error>
                                }
                            </mat-form-field>
                            <p>&</p>
                            <mat-form-field class="double-value-form-field-2">
                                <mat-label>Value</mat-label>
                                <input matInput [formControl]="criterionForm.controls.value2.controls.value" />
                                @if (criterionForm.controls.value2.controls.value.errors?.['required']) {
                                    <mat-error>Value required</mat-error>
                                } @else if (
                                    criterionForm.controls.value2.controls.value.errors?.['invalidInputForType']
                                ) {
                                    <mat-error>{{
                                        criterionForm.controls.value2.controls.value.errors!['invalidInputForType']
                                            .message
                                    }}</mat-error>
                                }
                            </mat-form-field>
                        </div>
                    }
                    @case ('textarea') {
                        <mat-form-field class="single-value-form-field">
                            <mat-label>Value</mat-label>
                            <textarea matInput [formControl]="criterionForm.controls.value1.controls.value"></textarea>
                            @if (criterionForm.controls.value1.controls.value.errors?.['required']) {
                                <mat-error>Value required</mat-error>
                            }
                        </mat-form-field>
                    }
                    @case ('typeahead') {
                        <div class="single-value-form-field">
                            <r1-compass-lib-typeahead-search
                                [valueFormControl]="criterionForm.controls.value1.controls.value"
                                [displayFormControl]="criterionForm.controls.value1.controls.value"
                                [resultDisplayPropertyPath]="'display'"
                                [resultValuePropertyPath]="'value'"
                                [disabled]="displayOnly()"
                                [searchResults]="valueTypeaheadResults"
                                (search)="onValueTypeahead($event)" />
                        </div>
                    }
                    @case ('picklist') {
                        <mat-form-field class="single-value-form-field">
                            <mat-label>Value</mat-label>
                            <mat-select [formControl]="criterionForm.controls.value1.controls.value">
                                @for (option of picklistOptions; track option) {
                                    <mat-option [value]="option.value">{{ option.displayName }}</mat-option>
                                }
                            </mat-select>
                            @if (criterionForm.controls.value1.controls.value.errors?.['required']) {
                                <mat-error>Value required</mat-error>
                            }
                        </mat-form-field>
                    }
                    @case ('multipick') {
                        <mat-form-field class="single-value-form-field">
                            <mat-label>Value</mat-label>
                            <mat-select
                                [formControl]="multipickFormControl"
                                (selectionChange)="onMultipickSelectChange()"
                                multiple>
                                @for (option of picklistOptions; track option) {
                                    <mat-option [value]="option.value">{{ option.displayName }}</mat-option>
                                }
                            </mat-select>
                            @if (multipickFormControl.errors?.['emptyArray']) {
                                <mat-error>Value(s) required</mat-error>
                            }
                        </mat-form-field>
                    }
                    @case ('date') {
                        <mat-form-field class="single-value-form-field">
                            <mat-label>Select a date</mat-label>
                            <input
                                matInput
                                readonly
                                [matDatepicker]="datePicker"
                                [formControl]="criterionForm.controls.value1.controls.value"
                                (click)="datePicker.open()"
                                (dateInput)="onDateInput($event, criterionForm.controls.value1.controls.value)" />
                            <fa-icon matSuffix class="picker-icon" [icon]="faCalendar" (click)="datePicker.open()" />
                            <mat-datepicker #datePicker />
                            @if (criterionForm.controls.value1.controls.value.errors?.['required']) {
                                <mat-error>Value required</mat-error>
                            } @else if (criterionForm.controls.value1.controls.value.errors?.['invalidInputForType']) {
                                <mat-error>{{
                                    criterionForm.controls.value1.controls.value.errors!['invalidInputForType'].message
                                }}</mat-error>
                            }
                        </mat-form-field>
                    }
                    @case ('date&date') {
                        <div class="double-value-form-container">
                            <mat-form-field class="double-value-form-field-1">
                                <mat-label>Select a start date</mat-label>
                                <input
                                    matInput
                                    readonly
                                    [matDatepicker]="datePicker1"
                                    [formControl]="criterionForm.controls.value1.controls.value"
                                    (click)="datePicker1.open()"
                                    (dateInput)="onDateInput($event, criterionForm.controls.value1.controls.value)" />
                                <fa-icon
                                    matSuffix
                                    class="picker-icon"
                                    [icon]="faCalendar"
                                    (click)="datePicker1.open()" />
                                <mat-datepicker #datePicker1 />
                                @if (criterionForm.controls.value1.controls.value.errors?.['required']) {
                                    <mat-error>Value required</mat-error>
                                } @else if (
                                    criterionForm.controls.value1.controls.value.errors?.['invalidInputForType']
                                ) {
                                    <mat-error>{{
                                        criterionForm.controls.value1.controls.value.errors!['invalidInputForType']
                                            .message
                                    }}</mat-error>
                                }
                            </mat-form-field>
                            <p>&</p>
                            <mat-form-field class="double-value-form-field-2">
                                <mat-label>Select an end date</mat-label>
                                <input
                                    matInput
                                    readonly
                                    [matDatepicker]="datePicker2"
                                    [formControl]="criterionForm.controls.value2.controls.value"
                                    (click)="datePicker2.open()"
                                    (dateInput)="onDateInput($event, criterionForm.controls.value2.controls.value)" />
                                <fa-icon
                                    matSuffix
                                    class="picker-icon"
                                    [icon]="faCalendar"
                                    (click)="datePicker2.open()" />
                                <mat-datepicker #datePicker2 />
                                @if (criterionForm.controls.value2.controls.value.errors?.['required']) {
                                    <mat-error>Value required</mat-error>
                                } @else if (
                                    criterionForm.controls.value2.controls.value.errors?.['invalidInputForType']
                                ) {
                                    <mat-error>{{
                                        criterionForm.controls.value2.controls.value.errors!['invalidInputForType']
                                            .message
                                    }}</mat-error>
                                }
                            </mat-form-field>
                        </div>
                    }
                    @case ('timeInterval') {
                        <div class="double-value-form-container">
                            <mat-form-field class="double-value-form-field-1">
                                <mat-label>Number</mat-label>
                                <input
                                    type="number"
                                    min="1"
                                    matInput
                                    [formControl]="criterionForm.controls.value1.controls.value" />
                                @if (criterionForm.controls.value1.controls.value.errors?.['required']) {
                                    <mat-error>Value required</mat-error>
                                } @else if (
                                    criterionForm.controls.value1.controls.value.errors?.['invalidInputForType']
                                ) {
                                    <mat-error>{{
                                        criterionForm.controls.value1.controls.value.errors!['invalidInputForType']
                                            .message
                                    }}</mat-error>
                                }
                            </mat-form-field>
                            <mat-form-field class="double-value-form-field-2">
                                <mat-label>Time unit</mat-label>
                                <mat-select [formControl]="criterionForm.controls.value2.controls.value">
                                    @for (option of timeIntervalOptions; track option) {
                                        <mat-option [value]="option.value">{{ option.name }}</mat-option>
                                    }
                                </mat-select>
                                @if (criterionForm.controls.value2.controls.value.errors?.['required']) {
                                    <mat-error>Value required</mat-error>
                                }
                            </mat-form-field>
                        </div>
                    }
                    @case ('nothing') {
                        <div [hidden]="true">
                            <mat-form-field>
                                <input matInput />
                            </mat-form-field>
                        </div>
                    }
                    @default {
                        <div [hidden]="true">
                            <mat-form-field>
                                <input matInput />
                            </mat-form-field>
                        </div>
                    }
                }
            </div>
        </div>
        <div class="criterion-options-container">
            @if (deletable()) {
                <div
                    class="trash-icon-container"
                    role="button"
                    aria-disabled="true"
                    (click)="onDelete()"
                    (keydown)="onDelete()">
                    <fa-icon [icon]="faTrash" />
                </div>
            } @else {
                <div class="empty-icon-container"></div>
            }
        </div>
    </div>
</div>
